var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status.loaded)?_c('div',{staticClass:"mb-4"},[(_vm.user.licenses.length > 0)?_c('user-licenses',{attrs:{"licenses":_vm.user.licenses}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }